// extracted by mini-css-extract-plugin
module.exports = {"btn_img":"BtnImg_btn_img__2tIEA"};